// /opt/ptg01-v1/front-extranet/lib/navEvent.ts
// Custom event broadcasté à chaque clic sur un item de navigation principale
// (sidebar desktop + bottom tab bar mobile).
//
// Permet aux pages list/detail (cras, depenses, missions, etc.) de réinitialiser
// leur sélection quand l'utilisateur reclique sur la même section depuis la nav.
// Utile sur mobile pour "remonter" au master (col 1) depuis le detail (col 2).
'use client';

import { useEffect } from 'react';

export const NAV_SECTION_EVENT = 'nx-nav-section-clicked';

/** Dispatch — à appeler dans onClick des Links Sidebar / BottomTabBar */
export function dispatchNavSectionClick() {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(new Event(NAV_SECTION_EVENT));
}

/** Hook — à utiliser dans les pages list/detail pour reset la sélection */
export function useNavSectionReset(handler: () => void) {
    useEffect(() => {
        const onNav = () => handler();
        window.addEventListener(NAV_SECTION_EVENT, onNav);
        return () => window.removeEventListener(NAV_SECTION_EVENT, onNav);
    }, [handler]);
}
